import cookie from 'react-cookies';
import { isClientSide } from '@r1-frontend/shared/helpers/ssr';

const getYmClientId = (): string | undefined => isClientSide() ? window['yaCounter30080914']?.getClientID() : undefined;

const COOKIE_YM_UID = '_ym_uid';

export const getYmIdValue = (): string | undefined => {
    try {
        const clientYAId: string | undefined = cookie.load(COOKIE_YM_UID);
        return clientYAId || getYmClientId();
    } catch {
        return undefined;
    }
};

